import { render, staticRenderFns } from "./terms-and-conditions.vue?vue&type=template&id=5b1c7824&scoped=true"
import script from "./terms-and-conditions.vue?vue&type=script&lang=js"
export * from "./terms-and-conditions.vue?vue&type=script&lang=js"
import style0 from "./terms-and-conditions.vue?vue&type=style&index=0&id=5b1c7824&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1c7824",
  null
  
)

export default component.exports